import query from "./query";
import config from "./config";
import event from "./event";
import pageview from "./pageview";
import screenview from "./screenview";
import customMap from "./custom-map";
import time from "./time";
import exception from "./exception";
import linker from "./linker";
import purchase from "./purchase";
import refund from "./refund";
import set from "./set";
import optIn from "./opt-in";
import optOut from "./opt-out";

export default {
  query,
  config,
  event,
  pageview,
  screenview,
  customMap,
  time,
  exception,
  linker,
  purchase,
  refund,
  set,
  optIn,
  optOut
};
